import styled from 'styled-components';

export const Container = styled.main`
    max-width: 1220px;
    margin: 0 auto;
    padding: 2.5rem 1rem;
`